import React, { Component } from 'react';

class NavBlockMiami extends Component {

  render() {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <div style={{ width: '78%', height: '15%', minHeight:'15%', borderRadius: '1vh', backgroundColor: 'white', padding: '3.72%' }}>
          <div style={{ color: 'black', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
            <div style={{ width:'26%', height:'18.72%' }}>
              <img alt="Donor Stories" src={this.props.icon} style={{ display: 'block',margin: 'auto', marginLeft:"-1.822916667vh", height:"7.291666667vh" }} />
            </div>
            <div style={{ width:"54%" }}>
              <span style={{ fontSize: this.props.containerWidth * 0.037222222, textAlign: "left", fontFamily: "opensans-bold", color: '#404040', float:"left" }}>
                {this.props.title}
                <div style={{ height:"0.5vh" }}></div>
                <span style={{ display: "block", fontSize: this.props.containerWidth * 0.025, color: '#404040', lineHeight: '1.5vh', textAlign: "left", fontFamily: "opensans-regular" }}>
                  {this.props.description}
                </span>
              </span>
            </div>
            <div style={{ width:"7%" }}>
              <span>
                <img alt="Forward" src={this.props.arrow} style={{ display: 'block', margin: 'auto', width: this.props.containerWidth * 0.059990741, float:"left" }} />
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }


}

export default NavBlockMiami;


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/NavBlockMiami.js